import { Directive } from '@angular/core';

@Directive({
  selector: '[appNew]'
})
export class NewDirective {

  constructor() { }

}
